import { ShieldCheck, BadgeCheck, Umbrella } from "lucide-react";

const CONFIG = {
  vetted: { label: "Vetted", Icon: ShieldCheck, cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  bonded: { label: "Bonded", Icon: BadgeCheck, cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  insured: { label: "Insured", Icon: Umbrella, cls: "bg-blue-500/10 text-blue-700 border-blue-500/30" },
};

export const TrustBadge = ({ type }) => {
  const c = CONFIG[type];
  if (!c) return null;
  const { label, Icon, cls } = c;
  return (
    <span data-testid={`badge-${type}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${cls}`}>
      <Icon size={13} /> {label}
    </span>
  );
};

export const BadgeRow = ({ badges }) => {
  if (!badges) return null;
  const active = Object.keys(CONFIG).filter((k) => badges[k]);
  if (!active.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {active.map((k) => <TrustBadge key={k} type={k} />)}
    </div>
  );
};
